"use client";

import { Avatar, Badge, Card, Flex, Heading, Text } from "@radix-ui/themes";
import FontAwesome from "../components/utilities/FontAwesome";

export default function ErrorPage(props: {
  statusCode?: number;
}): React.ReactElement {
  let title, description, icon, color: "red" | "gray";
  switch (props.statusCode) {
    case 500:
      title = "Whoops! Something went wrong.";
      description =
        "Don't worry, we're on it. The error has been logged and we're working hard to fix it.";
      icon = "fa-exclamation-triangle";
      color = "red";
      break;
    case 400:
      title = "Sorry, but you've reached a page that does not exist.";
      icon = "fa-magnifying-glass";
      color = "red";
      break;
    case 404:
    default:
      title = "Sorry, but you've reached a page that does not exist.";
      description =
        "This happened because you tried to access an invalid page or hostname.";
      icon = "fa-magnifying-glass";
      color = "red";
  }

  return (
    <Flex
      id="sb-main-content"
      direction="column"
      align="center"
      style={{ minHeight: "70vh", padding: "4rem 1.5rem" }}
    >
      <Flex
        direction="column"
        align="center"
        gap="5"
        style={{ maxWidth: 560, width: "100%" }}
      >
        <Card size="4" style={{ width: "100%" }}>
          <Flex direction="column" align="center" gap="4">
            <Avatar
              fallback={
                <FontAwesome prefix="fas" name={icon} size="lg" aria-hidden />
              }
              radius="full"
              color={color}
              variant="soft"
              size="5"
            />

            {props.statusCode && (
              <Badge color={color} variant="soft" size="2">
                Error {props.statusCode}
              </Badge>
            )}

            <Heading as="h1" size="6" align="center">
              {title}
            </Heading>

            {description && (
              <Text
                as="p"
                align="center"
                color="gray"
                size="3"
                style={{ maxWidth: 420 }}
              >
                {description}
              </Text>
            )}
          </Flex>
        </Card>
      </Flex>
    </Flex>
  );
}
